import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import screenOptions from '../config/screenOptions';
import {
  ConfirmLive, HowItWorksLive, PlanGymnasticLive, selectDateLive, ConfirmedSubscription
} from '../screens/company';
import { Chat } from '../screens/generic';

const CompanyPlans = createStackNavigator();

const CompanyPlansNavigator = () => (
  <CompanyPlans.Navigator screenOptions={screenOptions}>
    <CompanyPlans.Screen name="Como Funciona: Online" component={HowItWorksLive} />
    <CompanyPlans.Screen name="Plano: Online" component={PlanGymnasticLive} />
    <CompanyPlans.Screen name="Checkout: Selecione a data - Live" component={selectDateLive} />
    <CompanyPlans.Screen name="Company: Chat" component={Chat} />
    <CompanyPlans.Screen name="Checkout: Pagamento - Live" component={ConfirmLive} />
    <CompanyPlans.Screen name="Confirmed Subscription" component={ConfirmedSubscription} />
  </CompanyPlans.Navigator>
);

export default CompanyPlansNavigator;
